import React from "react";


const SocialMedia = () => {
    return(
        <div className="text-center mb-3">
        <a
          href="https://www.linkedin.com/in/pawel-jaskolski-995323b3/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fa fa-linkedin fa-2xl icon"></i>
        </a>
        <a
          href="https://github.com/PawelPavo"
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fa-brands fa-github fa-2xl mx-5 icon"></i>
        </a>
        <a
          href="https://www.instagram.com/pifpavchio/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fa-brands fa-instagram fa-2xl me-5 icon"></i>
        </a>
        <a
          href="mailto:pjpavo@gmail.com?subject=I found your website and now..."
          rel="noopener noreferrer"
          target="_blank"
        >
          <i className="fa-regular fa-envelope fa-2xl icon"></i>
        </a>
        
      </div>
    )
}

export default SocialMedia;